import { ReactNode, useState } from 'react';

import { DateView } from '@ui/components/DateView';
import { useMediaQuery } from '@providers/MediaQueryProvider';
import { SlimArrowButton } from '@ui/components/SlimArrowButton';

import { Achievement } from '@features/shared/api/typings';
import { SiteLayout } from '@features/shared/ui/SiteLayout';
import { PlayerAchievementLargePreview } from '@features/user/pages/PlayerAchievementLargePreview/PlayerAchievementLargePreview';
import { PlayerAchievementsListFull } from '@features/user/ui/PlayerAchievementsListFull/PlayerAchievementsListFull';
import { formatAchievementPlace } from '@features/user/utils/achievementPlace';

import styles from './PlayerAchievementsPage.module.css';

type Props = {
  actions: ReactNode;
  themeColor?: string | null;
  achievements?: Achievement[];
  onItemDownload?: (achievement: Achievement) => void;
  onLoadMore?: () => void;
  isLoading?: boolean;
  onBack: () => void;
};
export function PlayerAchievementsPage({
  actions,
  themeColor,
  achievements,
  onItemDownload,
  onLoadMore,
  isLoading,
  onBack,
}: Props) {
  const [visibleAchievement, setVisibleAchievement] = useState<null | Achievement>(null);
  const isMobile = useMediaQuery() === 'mobile';

  let achievementPlace = '';
  if (visibleAchievement) {
    achievementPlace = formatAchievementPlace(visibleAchievement.tournamentCertificate?.place);
  }

  return (
    <SiteLayout
      rootClassName={styles.layout}
      themeColor={themeColor}
      siteLogo={
        <div className={styles.siteLogoContainer}>
          <SlimArrowButton
            size={isMobile ? '28' : '32'}
            direction="left"
            onClick={visibleAchievement ? () => setVisibleAchievement(null) : onBack}
            colorPreset="golden"
          />
        </div>
      }
      centeredTitle={
        visibleAchievement ? (
          <div className={styles.achievementTitle}>
            <div className={styles.tournament}>
              {visibleAchievement.tournamentCertificate?.tournamentTitle}
            </div>
            <div className={styles.place}>{achievementPlace}</div>
            <div className={styles.date}>
              <DateView date={visibleAchievement.receiveTimestampMs} />
            </div>
          </div>
        ) : (
          <div className={styles.pageTitle}>Достижения</div>
        )
      }
      actions={actions}
      backgroundPreset="plain"
    >
      <div className={styles.content}>
        {visibleAchievement ? (
          <PlayerAchievementLargePreview
            achievement={visibleAchievement!}
            onClick={onItemDownload}
          />
        ) : (
          <PlayerAchievementsListFull
            achievements={achievements}
            isLoading={isLoading}
            onLoadMore={onLoadMore}
            onItemClick={setVisibleAchievement}
          />
        )}
      </div>
    </SiteLayout>
  );
}
